/* Devise d'affichage selon le lieu de connexion (fuseau horaire). Facturation en USD. */
export function detectCurrency() {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
  if (/Africa\/(Kinshasa|Lubumbashi)/.test(tz)) return "CDF";
  if (tz.startsWith("Europe/")) return "EUR";
  return "USD";
}

export function formatPrice(usd, currency, fx) {
  if (!usd) return "Gratuit";
  const rate = fx?.[currency] ?? 1;
  const v = usd * rate;
  if (currency === "CDF") return `${Math.round(v / 50) * 50} FC`;
  if (currency === "EUR") return `${v.toFixed(2).replace(".", ",")} €`;
  return `$${v.toFixed(2)}`;
}

export const PLAN_LABELS = {
  exercices: "Exercices guidés", tension: "Journal de tension", medicaments: "Médicaments & observance",
  carnet_mots: "Carnet de mots (aphasie)", messages: "Messagerie équipe de soin",
  aidants_illimites: "Aidants illimités", videos: "Vidéos de démonstration", rappels_sms: "Rappels SMS hors-ligne",
  historique_complet: "Historique complet", teleconsult_incluses: "2 téléconsultations / mois",
  messagerie_prioritaire: "Messagerie prioritaire", export_pdf: "Export PDF du dossier",
  dashboard: "Tableau de bord patients", alertes: "Alertes cliniques", notes_cliniques: "Notes & bilans",
  teleconsult: "Téléconsultations", praticiens_illimites: "Praticiens illimités", formation: "Formation VR des praticiens",
  statistiques: "Statistiques avancées",
};
